import { useCallback, useEffect, useState } from 'react';
import { apiFetch } from '../api/client';
import { useAuth } from '../contexts/AuthContext';

/**
 * Carrega atividades PENDENTES do módulo de contratos (sino / header).
 */
export default function useContratosAtividadesPendentes() {
  const { user, unidadeSelecionada } = useAuth();
  const usuarioEmail = user?.email || '';
  const usuarioTipo = user?.tipo || '';
  const usuarioSetor = user?.setor || '';
  const [pendentes, setPendentes] = useState([]);
  const [loading, setLoading] = useState(false);

  const carregar = useCallback(async () => {
    if (!usuarioEmail && !usuarioTipo && !usuarioSetor) {
      setPendentes([]);
      return;
    }
    setLoading(true);
    try {
      const params = new URLSearchParams({ status: 'PENDENTE' });
      if (usuarioEmail) params.append('usuarioEmail', usuarioEmail);
      if (usuarioTipo) params.append('usuarioTipo', usuarioTipo);
      if (usuarioSetor) params.append('usuarioSetor', usuarioSetor);
      if (unidadeSelecionada?.codigo) params.append('unidade', unidadeSelecionada.codigo);

      const res = await apiFetch(`/api/contratos/atividades?${params.toString()}`);
      if (!res.ok) throw new Error('Erro ao carregar atividades pendentes');
      const data = await res.json();
      setPendentes(Array.isArray(data) ? data : []);
    } catch {
      setPendentes([]);
    } finally {
      setLoading(false);
    }
  }, [usuarioEmail, usuarioTipo, usuarioSetor, unidadeSelecionada?.codigo]);

  useEffect(() => {
    carregar();
  }, [carregar]);

  useEffect(() => {
    const handleRefresh = () => carregar();
    window.addEventListener('contratos:refresh', handleRefresh);
    return () => window.removeEventListener('contratos:refresh', handleRefresh);
  }, [carregar]);

  return { pendentes, loading, recarregar: carregar, total: pendentes.length };
}
